export default __webpack_public_path__ + "static/media/slider4.c3bd162f.jpg";